import React, { PureComponent } from "react";
import { connect } from "react-redux";

import SelectAlbumComponent from "./SelectAlbumComponent";
//import PropTypes from "prop-types";

import { fetchAlbums, saveAlbum } from "Thunks";
import { displaySidebarAlbums, setAlbumEditor } from "Actions";

class SelectAlbumContainer extends PureComponent {
  state = {
    displaySelectedMedia: false
  };

  componentDidMount() {
    const { fetchAlbums } = this.props;
    fetchAlbums({ limit: 50, isPersonal: ["0", "1"] });
  }

  handleClickClose = e => {
    const { displaySidebarAlbums } = this.props;
    document
      .getElementsByClassName("sidebarContent")
      .item(0)
      .classList.remove("active");
    setTimeout(arg => {
      displaySidebarAlbums(false);
    }, 500);
  };

  addNewAlbum = e => {
    const { setAlbumEditor } = this.props;

    //TODO obtenir selectedMedia depuis le store
    const checks = document.getElementsByClassName("check");
    let medias = [];
    for (let el of checks) {
      if (!el.classList.contains("disabled")) {
        const sibling = el.previousSibling;
        medias.push({
          id: sibling.id.split("-")[1],
          path: $(sibling)
            .find("img:last")
            .attr("src"),
          title: $(sibling)
            .find("h4")
            .text()
        });
      }
    }
    setAlbumEditor({
      medias,
      album: null,
      isOpen: true,
      color: 1,
      withNav: false
    });
  };
  handleClickAlbum = e => {
    this.setState({ selected: [] });
  };

  handleClickAlbum1 = e => {
    e.stopPropagation();
    e.preventDefault();
    const {
      saveAlbum,
      albums,
      lng,
      displaySidebarAlbums,
      selected
    } = this.props;
    const target = e.currentTarget;
    target.parentElement.classList.add("scale1_2");

    this.setState({ displaySelectedMedia: true });

    //TODO obtenir selectedMedia depuis le store
    // const checks = document.getElementsByClassName("check");
    // let medias = [];
    // for (let el of checks) {
    //   if (!el.classList.contains("disabled")) {
    //     const sibling = el.previousSibling;
    //     medias.push({
    //       id: sibling.id.split("-")[1],
    //       path: $(sibling)
    //         .find("img:last")
    //         .attr("src"),
    //       title: $(sibling)
    //         .find("h4")
    //         .text()
    //     });
    //   }
    // }

    const id = target.parentElement.id.split("-").pop();
    const album = albums.filter(
      el => parseInt(el.id, 10) === parseInt(id, 10)
    )[0];

    const { color } = album;
    const lngTitle = `title${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
    const lngDesc = `description${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    setTimeout(e => {
      document.getElementById("selectedContainer").classList.add("compressed");
    }, 20);
    setTimeout(e => {
      this.setState({ displaySelectedMedia: false });
      saveAlbum({
        id,
        title: album[lngTitle],
        description: album[lngDesc],
        color,
        mediaIds: selected.map(media => media.id)
      }).then(resp => {
        target.parentElement.classList.remove("scale1_2");
        displaySidebarAlbums(false);

        $(".check").addClass("disabled");
        $(".check").css("display", "none");

        document.getElementById("bubbles").classList.remove("active");

        const albumArea = document.getElementById("album-area");
        albumArea &&
          window.scrollTo(
            0,
            albumArea.getBoundingClientRect().top + window.scrollY
          );
      });
    }, 520);
    return false;
  };

  render() {
    const { albums, fetching, error, ...props } = this.props;

    let fetchingState = "none";

    if (fetching) {
      fetchingState = "fetching";
    } else if (error && error.code !== 404) {
      fetchingState = "error";
    } else if (error && error.code === 404) {
      fetchingState = "success";
    } else {
      fetchingState = "success";
    }

    return (
      <SelectAlbumComponent
        albums={albums}
        displaySelectedMedia={this.state.displaySelectedMedia}
        fetchingState={fetchingState}
        onClickClose={this.handleClickClose}
        onClikAddNewAlbum={this.addNewAlbum}
        {...props}
      />
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  albums: state.albums.items,
  fetching: state.albums.fetching,
  //fetched: state.albums.fetched,
  error: state.albums.error,
  lng: state.params.lng,
  selected: state.usedMedias.selected
});

const mapDispatchToProps = dispatch => ({
  saveAlbum: options => dispatch(saveAlbum(options)),
  fetchAlbums: options => dispatch(fetchAlbums(options)),
  displaySidebarAlbums: visible => dispatch(displaySidebarAlbums(visible)),
  setAlbumEditor: mediaEditor => dispatch(setAlbumEditor(mediaEditor))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectAlbumContainer);



// WEBPACK FOOTER //
// ./src/components/Community/SelectAlbum/SelectAlbumContainer.js